<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="发生时间" prop="createTime">
        <el-date-picker v-model="searchForm.createTime" value-format="yyyy-MM-dd" placeholder="请选择发生时间" @change="search"/>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="templateName" label="模版名称" min-width="100px"></el-table-column>
        <el-table-column prop="errorMessage" label="错误消息" min-width="100px">
          <ColumnDetail slot-scope="{ row }" :content="row.errorMessage" />
        </el-table-column>
        <el-table-column prop="createTime" label="发生时间" min-width="140px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="操作人" min-width="100px"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import ColumnDetail from '../../components/common/ColumnDetail'
export default {
  name: 'GenerateErrorLogList',
  extends: BaseTable,
  components: { ColumnDetail, TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        createTime: ''
      }
    }
  },
  created () {
    this.config({
      module: '生成错误日志',
      api: '/generate/errorLog',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
